import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/object/from-entries';
import 'core-js/features/object/values';
import 'core-js/features/promise/finally';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import '@groupelacentrale/contact-storybook/lib/main.css';
import '@groupelacentrale/contact-storybook/lib/icons.css';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/react';

import { App } from 'app';
import { AppProvider } from 'providers';
import { ErrorBoundary } from 'components';
import { config } from 'config';
import './index.scss';

const history = createBrowserHistory();

Sentry.init({
  tracesSampleRate: 0.01,
  dsn: config.SENTRY_DSN,
  environment: config.SENTRY_ENV,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  release: process.env.REACT_APP_RELEASE,
});

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <ErrorBoundary>
        <AppProvider>
          <App />
        </AppProvider>
      </ErrorBoundary>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);
